import { Component, type ErrorInfo, type ReactNode } from "react";

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  error: Error | null;
}

export class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("学习中心未捕获异常", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main id="main-content" tabIndex={-1}>
        <section role="alert" aria-labelledby="fatal-error-title">
          <p>应用未能继续运行</p>
          <h1 id="fatal-error-title">学习数据尚未丢失</h1>
          <p>
            请先重新加载。若问题重复出现，请保留当前页面并导出诊断信息。
          </p>
          {import.meta.env.DEV ? (
            <details>
              <summary>开发诊断</summary>
              <pre>{this.state.error.message}</pre>
            </details>
          ) : null}
          <button type="button" onClick={() => window.location.reload()}>
            重新加载学习中心
          </button>
        </section>
      </main>
    );
  }
}
